import { useRef } from "react";
import { useInView } from "framer-motion";

const GOLD = "#D4AF37";
const ROSE = "#D88C9A";
const ROSE_LIGHT = "#F3D9DC";
const CREAM_SOFT = "#F9F6F0";
const GOLD_SOFT = "#F1E3C0";

const S = ({ children, className }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

const GRAPHICS = {
  "personalised-gifts": (
    <>
      <path className="fill-part" d="M18 24h24v18a7 7 0 0 1-7 7H25a7 7 0 0 1-7-7V24z" fill={CREAM_SOFT} stroke="none" />
      <path d="M18 24h24v18a7 7 0 0 1-7 7H25a7 7 0 0 1-7-7V24z" />
      <path d="M42 27h4a6 6 0 0 1 0 12h-4" />
      <path
        className="fill-part"
        d="M30 33.5c-2.6-2.9-6.2-1.5-6.2.9 0 2 3.1 4.2 6.2 5.8 3.1-1.6 6.2-3.8 6.2-5.8 0-2.4-3.6-3.8-6.2-.9z"
        fill={ROSE}
        stroke="none"
      />
      <path d="M24 19c0-2.2 2-2.2 2-4.4" stroke={GOLD} />
      <path d="M31 19c0-2.2 2-2.2 2-4.4" stroke={GOLD} />
    </>
  ),
  "curated-hampers": (
    <>
      <path className="fill-part" d="M14 30h36l-3.5 17a5 5 0 0 1-5 4h-19a5 5 0 0 1-5-4L14 30z" fill={CREAM_SOFT} stroke="none" />
      <path d="M14 30h36l-3.5 17a5 5 0 0 1-5 4h-19a5 5 0 0 1-5-4L14 30z" />
      <path d="M22 30c0-7 4.5-11 10-11s10 4 10 11" stroke={GOLD} />
      <path className="fill-part" d="M32 18c-3.5-4.5-9-4.5-9-1s4.5 3.5 9 1z" fill={ROSE} stroke="none" />
      <path className="fill-part" d="M32 18c3.5-4.5 9-4.5 9-1s-4.5 3.5-9 1z" fill={ROSE} stroke="none" />
      <circle className="fill-part" cx="32" cy="17.6" r="1.8" fill={GOLD} stroke="none" />
      <path d="M20 38h24" />
      <path d="M21.5 44h21" />
    </>
  ),
  "gift-concierge": (
    <>
      <path className="fill-part" d="M15 30h30v6.5H15z" fill={ROSE_LIGHT} stroke="none" />
      <rect x="15" y="30" width="30" height="20" rx="2" />
      <path d="M15 36.5h30" />
      <path d="M30 30v20" stroke={GOLD} />
      <path d="M42 13l8 8" />
      <path className="fill-part" d="M50 8l1.2 3 3 1.2-3 1.2L50 16.5l-1.2-3.1-3-1.2 3-1.2L50 8z" fill={GOLD} stroke="none" />
      <path d="M20 13l1 2.6 2.6 1-2.6 1-1 2.6-1-2.6-2.6-1 2.6-1 1-2.6z" stroke={GOLD} />
    </>
  ),
  "signature-scents": (
    <>
      <path className="fill-part" d="M22 30h20v13a9 9 0 0 1-9 9h-2a9 9 0 0 1-9-9V30z" fill={ROSE_LIGHT} stroke="none" />
      <path d="M22 30h20v13a9 9 0 0 1-9 9h-2a9 9 0 0 1-9-9V30z" />
      <path d="M26 30v-5h12v5" />
      <path className="fill-part" d="M28 17h8v8h-8z" fill={GOLD_SOFT} stroke="none" />
      <path d="M28 25v-8h8v8" stroke={GOLD} />
      <path
        className="fill-part"
        d="M32 37.5c-2-2.2-4.6-1.1-4.6.8 0 1.6 2.3 3.2 4.6 4.4 2.3-1.2 4.6-2.8 4.6-4.4 0-1.9-2.6-3-4.6-.8z"
        fill={ROSE}
        stroke="none"
      />
      <path d="M49 12l.9 2.3 2.3.9-2.3.9-.9 2.3-.9-2.3-2.3-.9 2.3-.9.9-2.3z" stroke={GOLD} />
    </>
  ),
  "weddings-engagements": (
    <>
      <circle cx="25" cy="37" r="11" />
      <circle cx="40" cy="37" r="11" stroke={GOLD} />
      <path className="fill-part" d="M25 23l-3.5-4.5L25 14l3.5 4.5L25 23z" fill={ROSE_LIGHT} stroke="none" />
      <path d="M25 23l-3.5-4.5L25 14l3.5 4.5L25 23z" />
    </>
  ),
  "event-stationery": (
    <>
      <path className="fill-part" d="M15 21h34a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V23a2 2 0 0 1 2-2z" fill={CREAM_SOFT} stroke="none" />
      <rect x="13" y="21" width="38" height="26" rx="2" />
      <path d="M13 23l19 13.5L51 23" />
      <path
        className="fill-part"
        d="M32 39.5c-2-2.2-4.6-1.1-4.6.8 0 1.6 2.3 3.2 4.6 4.4 2.3-1.2 4.6-2.8 4.6-4.4 0-1.9-2.6-3-4.6-.8z"
        fill={ROSE}
        stroke="none"
      />
    </>
  ),
  "home-decor": (
    <>
      <path className="fill-part" d="M19 30h26v19H19z" fill={CREAM_SOFT} stroke="none" />
      <path d="M13 33L32 17l19 16" />
      <path d="M19 30v19h26V30" />
      <path
        className="fill-part"
        d="M32 36.5c-2.2-2.4-5-1.2-5 .9 0 1.7 2.5 3.4 5 4.7 2.5-1.3 5-3 5-4.7 0-2.1-2.8-3.3-5-.9z"
        fill={ROSE}
        stroke="none"
      />
      <path d="M28 49v-6h8v6" stroke={GOLD} />
    </>
  ),
  "custom-apparel": (
    <>
      <path className="fill-part" d="M24 16l-10 6 4 8 4-2v20h20V28l4 2 4-8-10-6c0 3-3.6 5-8 5s-8-2-8-5z" fill={CREAM_SOFT} stroke="none" />
      <path d="M24 16l-10 6 4 8 4-2v20h20V28l4 2 4-8-10-6c0 3-3.6 5-8 5s-8-2-8-5z" />
      <path
        className="fill-part"
        d="M32 33.5c-1.8-2-4.2-1-4.2.7 0 1.5 2.1 3 4.2 4.1 2.1-1.1 4.2-2.6 4.2-4.1 0-1.7-2.4-2.7-4.2-.7z"
        fill={ROSE}
        stroke="none"
      />
    </>
  ),
  "print-personalise": (
    <>
      <path className="fill-part" d="M16 13h32v38H16z" fill={CREAM_SOFT} stroke="none" />
      <rect x="16" y="13" width="32" height="38" rx="2" />
      <path d="M23 41l7-11 5 7 4-4 4 8" stroke={GOLD} />
      <circle className="fill-part" cx="25" cy="22" r="2.5" fill={GOLD} stroke="none" />
      <path className="fill-part" d="M52 8l.8 2.2L55 11l-2.2.8L52 14l-.8-2.2L49 11l2.2-.8L52 8z" fill={ROSE} stroke="none" />
    </>
  ),
  "corporate-gifting": (
    <>
      <path className="fill-part" d="M13 28h27v6.5H13z" fill={ROSE_LIGHT} stroke="none" />
      <rect x="13" y="28" width="27" height="22" rx="2" />
      <path d="M13 34.5h27" />
      <path d="M26.5 28v22" stroke={GOLD} />
      <path className="fill-part" d="M42 18l9 9-9.5 9.5-9-9L42 18z" fill={GOLD_SOFT} stroke="none" />
      <path d="M42 18l9 9-9.5 9.5-9-9L42 18z" stroke={GOLD} />
      <circle className="fill-part" cx="39.5" cy="23.5" r="1.4" fill={ROSE} stroke="none" />
    </>
  ),
  "branded-merchandise": (
    <>
      <path className="fill-part" d="M17 24h30l-2.2 24a3.5 3.5 0 0 1-3.5 3.2H22.7a3.5 3.5 0 0 1-3.5-3.2L17 24z" fill={CREAM_SOFT} stroke="none" />
      <path d="M17 24h30l-2.2 24a3.5 3.5 0 0 1-3.5 3.2H22.7a3.5 3.5 0 0 1-3.5-3.2L17 24z" />
      <path d="M25 24v-3a7 7 0 0 1 14 0v3" stroke={GOLD} />
      <path
        className="fill-part"
        d="M32 36.5c-2-2.2-4.6-1.1-4.6.8 0 1.6 2.3 3.2 4.6 4.4 2.3-1.2 4.6-2.8 4.6-4.4 0-1.9-2.6-3-4.6-.8z"
        fill={ROSE}
        stroke="none"
      />
    </>
  ),
  "business-branding": (
    <>
      <path className="fill-part" d="M32 14a11 11 0 1 1 0 22 11 11 0 0 1 0-22z" fill={CREAM_SOFT} stroke="none" />
      <circle cx="32" cy="25" r="11" />
      <path
        className="fill-part"
        d="M32 19.5l1.6 3.9 4.2.3-3.2 2.7 1 4.1-3.6-2.3-3.6 2.3 1-4.1-3.2-2.7 4.2-.3L32 19.5z"
        fill={GOLD}
        stroke="none"
      />
      <path d="M24.5 33.5L21 49l11-6 11 6-3.5-15.5" stroke={GOLD} />
    </>
  ),
  "custom-packaging": (
    <>
      <path className="fill-part" d="M13 25l19-8 19 8-19 8-19-8z" fill={ROSE_LIGHT} stroke="none" />
      <path d="M13 25l19-8 19 8-19 8-19-8z" />
      <path d="M13 25v16l19 8V33" />
      <path d="M51 25v16l-19 8" />
      <path d="M32 17v16" stroke={GOLD} />
      <path className="fill-part" d="M32 15c-3-4-8-4-8-1.2S28 17 32 15z" fill={ROSE} stroke="none" />
      <path className="fill-part" d="M32 15c3-4 8-4 8-1.2S36 17 32 15z" fill={ROSE} stroke="none" />
    </>
  ),
  "occasion-websites": (
    <>
      <path className="fill-part" d="M12 18a3 3 0 0 1 3-3h34a3 3 0 0 1 3 3v5H12v-5z" fill={ROSE_LIGHT} stroke="none" />
      <rect x="12" y="15" width="40" height="34" rx="3" />
      <path d="M12 23h40" />
      <circle className="fill-part" cx="17" cy="19" r="1.3" fill={GOLD} stroke="none" />
      <circle className="fill-part" cx="22" cy="19" r="1.3" fill={ROSE} stroke="none" />
      <path
        className="fill-part"
        d="M32 31.5c-2.4-2.6-5.4-1.3-5.4.9 0 1.8 2.7 3.6 5.4 5 2.7-1.4 5.4-3.2 5.4-5 0-2.2-3-3.5-5.4-.9z"
        fill={ROSE}
        stroke="none"
      />
      <path d="M18 44h12" stroke={GOLD} />
    </>
  ),
  "small-business-digital": (
    <>
      <path className="fill-part" d="M15 17h34v21H15z" fill={CREAM_SOFT} stroke="none" />
      <rect x="12" y="14" width="40" height="27" rx="3" />
      <path d="M26 48h12" />
      <path d="M32 41v7" />
      <path className="fill-part" d="M28 22l11 6.5-5.3 1.2-2.2 5.3L28 22z" fill={GOLD} stroke="none" />
      <path d="M28 22l11 6.5-5.3 1.2-2.2 5.3L28 22z" stroke={GOLD} />
    </>
  ),
};

export const ServiceGraphic = ({ slug, className = "w-10 h-10" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={inView ? "draw-lines" : ""} style={{ display: "contents" }}>
      <S className={className}>{GRAPHICS[slug]}</S>
    </span>
  );
};
